import React from "react";
import { push } from "connected-react-router";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { useDispatch } from "react-redux";

const useStyles = makeStyles(() => ({
  root: {
    width: 300,
    margin: "0 auto",
    borderRadius: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    paddingTop: 20,
  },
  footContent: {
    padding: 8,
    "&:last-child": {
      paddingBottom: 8,
    },
  },
  backBlack: {
    backgroundColor: "black",
  },
  backWhite: {
    backgroundColor: "white",
  },
  boothName: {
    fontWeight: 500,
    boxOrient: "vertical",
    display: "-webkit-box",
    fontSize: 18,
    lineHeight: "20px",
    overflow: "hidden",
  },
  textBlack: {
    color: "#3f3f3f",
  },
  textWhite: {
    color: "white",
  },
  organizerName: {
    fontWeight: 400,
    boxOrient: "vertical",
    display: "-webkit-box",
    fontSize: 12,
    lineHeight: "12px",
    overflow: "hidden",
    paddingLeft: 2,
  },
  mincho: {
    fontFamily: ["Hiragino Mincho ProN", "ヒラギノ明朝 ProN", "serif"].join(","),
  },
  minchoA: {
    fontFamily: "Hiragino Mincho ProN",
  },
  gothic: {
    fontFamily: ["Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "sans-serif"].join(","),
  },
  flexWrap: {
    display: "flex",
  },
  icon: {
    marginRight: 0,
    marginLeft: "auto",
  },
  media: {
    height: 100,
    width: "calc(100% / 3)",
    objectFit: "cover",
  },
}));

const MyBoothCard = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectOpuses = props.selectOpuses;
  const isBlack = props.isBlack;
  const isGothic = props.isGothic;

  return (
    <Card className={classes.root}>
      <div onClick={() => dispatch(push("/booth/edit/" + props.id))}>
        <CardContent className={classes.content + " " + (isBlack !== false ? classes.backBlack : classes.backWhite)}>
          <Typography
            className={
              classes.boothName +
              " " +
              (isBlack !== false ? classes.textWhite : classes.textBlack) +
              " " +
              (isGothic !== false ? classes.gothic : classes.mincho)
            }
          >
            {props.boothName}
          </Typography>

          <div className="spacer-box--ss"></div>
          <Typography
            className={
              classes.organizerName +
              " " +
              (isBlack !== false ? classes.textWhite : classes.textBlack) +
              " " +
              (isGothic !== false ? classes.gothic : classes.mincho)
            }
          >
            {props.organizerName}
          </Typography>
        </CardContent>
      </div>
      <div className={classes.flexWrap}>
        <CardMedia
          className={classes.media}
          image={selectOpuses[0].images[0].path}
          onClick={() => dispatch(push("/booth/edit/" + props.id))}
          title=""
        />
        <CardMedia
          className={classes.media}
          image={selectOpuses[1].images[0].path}
          onClick={() => dispatch(push("/booth/edit/" + props.id))}
          title=""
        />
        <CardMedia
          className={classes.media}
          image={selectOpuses[2].images[0].path}
          onClick={() => dispatch(push("/booth/edit/" + props.id))}
          title=""
        />
      </div>
      <CardContent className={classes.footContent}>
        <div onClick={() => dispatch(push("/booth/edit/" + props.id))}>
          <div className="flex-row">
            <div className="row-spacer--s"></div>
            <div className="timezone-text">開催：{props.liveDay}</div>

            <div className="flex-row--justright liveon-text">LIVE：{props.liveTime}</div>

            <div className="row-spacer--s"></div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default MyBoothCard;
